// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"bd12503b58dfcda8","6831":"648807d2f98af1a5","8503":"fc36d5258c4a1892","9683":"201c8dc892f72a95"}[chunkId] + ".js";
};